import { initStandaloneJobDetailViewCount } from './api/jobs.js';
import { initLocationFilterModal, initFaqSections, initPressSections, initBlogSections } from './features/content-filters.js';
import cookieConsentApi from './features/cookie-consent.js';
import { initDataUrlLinks } from './features/data-url-links.js';
import { initEmbedMode } from './features/embed-mode.js';
import { initContactForms } from './features/forms.js';
import { initJobCards } from './features/job-cards.js';
import { initJobDetailBackButton, initJobDetailVideo, initJobMenuModal, initAppDownloadModal } from './features/job-ui.js';
import { initLanguageSwitcher } from './features/language-switcher.js';
import { initTestimonialsSections, initWhyVideo, initHeroGalleryVideo, initHeroCtaScroll } from './features/media.js';
import { initAccordions, initMobileMenu, initTabs } from './features/navigation.js';
import { initSliderSections } from './features/slider.js';
import telemetryApi from './telemetry.js';

initEmbedMode();

document.addEventListener('DOMContentLoaded', async () => {
  let telemetryInitialized = false;

  cookieConsentApi.init({
    onTelemetryChange: () => {
      if (!telemetryInitialized) {
        telemetryApi.init();
        telemetryInitialized = true;
      }
    },
  });

  if (!telemetryInitialized) {
    telemetryApi.init();
    telemetryInitialized = true;
  }

  initMobileMenu();
  initLanguageSwitcher();
  initDataUrlLinks();
  initTabs();
  initAccordions();
  initFaqSections();
  initPressSections();
  initBlogSections();
  initContactForms();
  initSliderSections();
  initTestimonialsSections();
  initWhyVideo();
  initHeroGalleryVideo();
  initHeroCtaScroll();
  initJobDetailVideo();
  initJobMenuModal();
  initAppDownloadModal();
  initLocationFilterModal();
  initJobDetailBackButton();
  initStandaloneJobDetailViewCount();
  await initJobCards();
});
